module.exports = __webpack_public_path__ + "static/media/福利地图@2x.bfee65d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_172/images/福利地图@2x.png
// module id = 1584
// module chunks = 0